<script setup lang="ts">
interface AppNavItemProps {
  text: string;
}

const props = defineProps<AppNavItemProps>();

interface AppNavItemEmits {
  (event: 'click'): void;
}

const emit = defineEmits<AppNavItemEmits>();
</script>

<template>
  <button class="app-nav-item" @click="emit('click')">{{ props.text }}</button>
</template>

<style scoped lang="scss">
@import '../../styles/_fonts.scss';
.app-nav-item {
  color: var(--color-neutral-70);
  @include font-label-m-bold;
  cursor: pointer;
  padding: 0;
  margin: 0;

  // normalize button
  border: none;
  outline: none;
  background: transparent;
}
</style>
